import angular from 'angular';
import moment from 'moment';

angular
  .module('cxSettings')
  .controller('InvalidEmailWarningDialogCtrl', [
    '$element',
    '$http',
    'appUrls',
    'flySvc',
    'close',
    invalidEmailWarningDialogCtrl,
  ]);

function invalidEmailWarningDialogCtrl($element, $http, appUrls, flySvc, close) {
  var vm = this;

  vm.remove = function() {
    close(true, 500);
    $element.modal('hide');
  };

  vm.cancel = function() {
    close(null, 500);
    $element.modal('hide');
  };
}
